import type { ProductCode } from '../../core/api/types';
import { resolveProductUrl } from '../../core/productUrls';

/** Resolve the environment before requesting a one-time launch grant. */
export function productDestination(
  productCode: ProductCode,
  storedUrl: string,
  platformOrigin: string,
  development = import.meta.env.DEV,
): URL {
  const configured = resolveProductUrl(productCode, storedUrl.trim(), development);
  if (!configured) throw new Error('The product launch URL is not configured.');
  const destination = new URL(configured, platformOrigin);
  if (!['http:', 'https:'].includes(destination.protocol) || destination.username || destination.password) {
    throw new Error('The product launch URL must use HTTP or HTTPS without embedded credentials.');
  }
  return destination;
}
